import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import * as BasketNS from '@emersya/mpa-basket';
import {Input, Field, Block, InputButton, InputNumber, InputText, InputSelect} from '@emersya/mpa-components';

export interface IOMSCustomerFormComponentValue {
	nameFirst: string;
	nameLast: string;
	company: string;
	email: string;
	phone: string;
	country: string;
	event: string;
	booth: string;
	function: string;
	address: string;
	zipCode: number;
	city: string;
	standPositionA: {
		hall: string;
		// aisle : string;
		// number : number;
		position: string;
	};
	isTOSAccepted: boolean;
};

export interface IOMSCustomerFormComponentConfiguration extends Input.Configuration<
	IOMSCustomerFormComponentValue,
	IOMSCustomerFormComponentValue
> {
	readonly fields: string[];
};

export class OMSCustomerFormComponent extends Input.Component<
	HTMLDivElement,
	IOMSCustomerFormComponentValue,
	IOMSCustomerFormComponentValue,
	OMSCustomerFormComponent,
	IOMSCustomerFormComponentConfiguration
> {
	component_DOM: HTMLDivElement;

	override async component_start(ev: STD.events.Event<any, CM.Component<any, any>>) {
		const inputSelectCountry = <InputSelect.Component>this.component_find('@:fields.country.field');
		const components = <CM.DOMComponent<any, any, any>[]>inputSelectCountry.component_outerChilds;
		components.sort((lhs, rhs) => {
			return lhs.component_DOM.textContent.localeCompare(rhs.component_DOM.textContent);
		});
		for (const component of components) {
			component.component_DOM.parentElement.appendChild(component.component_DOM);
		}
		await super.component_start(ev);
		if (app.parameters.test) {
			await (<any>this.component_find('@:fields.nameFirst.field')).updateValue('-nameFirst');
			await (<any>this.component_find('@:fields.nameLast.field')).updateValue('-nameLast');
			await (<any>this.component_find('@:fields.company.field')).updateValue('-company');
			await (<any>this.component_find('@:fields.email.field')).updateValue('-email@z');
			await (<any>this.component_find('@:fields.phone.field')).updateValue('-phone');
			// await (<any> this.component_find('@:fields.country.field')).updateValue('-');
			await (<any>this.component_find('@:fields.booth.field')).updateValue('-booth');
			await (<any>this.component_find('@:fields.function.field')).updateValue('-function');
			await (<any>this.component_find('@:fields.address.field')).updateValue('-address');
			await (<any>this.component_find('@:fields.zipCode.field')).updateValue(1234);
			await (<any>this.component_find('@:fields.city.field')).updateValue('-city');
			await (<any>this.component_find('@:fields.standPositionA.hall.field')).updateValue('H');
			// await (<any> this.component_find('@:fields.standPositionA.aisle.field')).updateValue('A');
			// await (<any> this.component_find('@:fields.standPositionA.number.field')).updateValue(12);
			await (<any>this.component_find('@:fields.standPositionA.position.field')).updateValue('A 12');
			await (<any>this.component_find('@:fields.agreeTermsAndCondition.field')).updateValue(true);
		}
		await (<any>this.component_find('@:fields.event.field')).updateValue('SIAE 2025');
		const inputSelectCountryValue = inputSelectCountry.value;
		if (!inputSelectCountryValue) {
			this.component_throwUserError('Country selector with no country selected!', {inputSelectCountry});
		}
		const idCountryValue = inputSelectCountryValue.id;
		if (!this.value) {
			this.component_throwUserError('', {});
		}
		if (idCountryValue) {
			this.value.country = idCountryValue;
		}
		const customTextList = this.getCustomTextInput();
		for (const field of customTextList) {
			if (field.parent) {
				await this.component_find('@:fields.' + field.parent + '.' + field.id + '.lengthAlert').component_disable();
			} else {
				await this.component_find('@:fields.' + field.id + '.lengthAlert').component_disable();
			}
		}
	};

	override isValueTheDefault() {
		return (!!(
			this.value &&
			this.defaultValue &&
			STD.object.hasSameContentDeeply(this.value, this.defaultValue)
		));
	};

	override deserialize(x: IOMSCustomerFormComponentValue) {
		return (<IOMSCustomerFormComponentValue><any>x);
	};

	updateCountrySelector(ev: STD.events.Event<any, CM.Component<any, any>>) {
		const newValue = ev.details.newValue.id;
		const oldValue = ev.details.oldValue.id;
		if (oldValue != newValue) {
			const inputSelectCountry = <InputSelect.Component>this.component_find('@:fields.country.field');
			const components = <CM.DOMComponent<any, any, any>[]>inputSelectCountry.component_outerChilds;
			components.sort((lhs, rhs) => {
				return lhs.component_DOM.textContent.localeCompare(rhs.component_DOM.textContent);
			});
			for (const component of components) {
				component.component_DOM.parentElement.appendChild(component.component_DOM);
			}
		}
	}

	getMandatoryFields() {
		const list: string[] = [
			'nameFirst',
			'nameLast',
			'phone',
			'email',
			'country',
			'company',
			'address',
			'zipCode',
			'city',
			'event',
			'standPositionA'
		];
		return list;
	}

	getCustomTextInput() {
		return [
			{
				id: 'position',
				parent: 'standPositionA',
				length: 5
			},
			{
				id: 'company',
				length: 14
			}
		];
	}

	async onFieldsUpdated(ev: STD.events.Event<any, CM.Component<any, any>>) {
		if (!this.value) {
			this.component_throwLibraryError('', {});
		}
		if (ev.target.id === 'form') {
			return;
		}
		const input = <Input.Component<any, any, any, any, any>>ev.target;
		const field = <Field.Component>input.component_parent;
		const container = <Block.Component>field.component_parent;
		let k0;
		let k1;
		// let newValue : ICustomerFormComponentValue;
		const newValue: IOMSCustomerFormComponentValue = STD.object.deepMerge({}, this.value);
		let newFieldValue = ev.details.newValue;
		if (container.id === 'fields') {
			k0 = field.id;
			if (k0 === 'agreeTermsAndCondition') {
				k0 = 'isTOSAccepted';
			}
			if (k0 === 'country') {
				newFieldValue = newFieldValue.id;
				const inputSelectCountry = <InputSelect.Component>this.component_find('@:fields.country.field');
				const components = <CM.DOMComponent<any, any, any>[]>inputSelectCountry.component_outerChilds;
				components.sort((lhs, rhs) => {
					return lhs.component_DOM.textContent.localeCompare(rhs.component_DOM.textContent);
				});
				for (const component of components) {
					component.component_DOM.parentElement.appendChild(component.component_DOM);
				}
			}
			// newValue = <ICustomerFormComponentValue> STD.object.deepMerge(this.value, {
			// 	[ k0 ] : ev.details.newValue
			// });
			Object.assign(newValue, {[k0]: newFieldValue});
		} else {
			if (container.id !== 'standPositionA') {
				return;
			}
			k0 = container.id;
			k1 = field.id;
			Object.assign((<any>newValue)[k0], {[k1]: newFieldValue});
		}
		await this.updateValue(newValue);
		await this.checkAllField();
	};

	async checkAllField() {
		const form = this.component_find('@:fields');
		const mandatoryFields = this.getMandatoryFields();
		const customTextList = this.getCustomTextInput();
		let isFilled = true;
		for (const child of form.component_outerChilds) {
			if (mandatoryFields.includes(child.id)) {
				if (child.id === 'standPositionA') {
					for (const grandChild of child.component_outerChilds) {
						const field = grandChild.component_outerChilds.find(x => x.id === 'field');
						if (field instanceof InputNumber.Component) {
							if (Number.isNaN(field.value)) {
								await field.updateValue(0);
							}
							if (field.value === 0) {
								isFilled = false;
							}
						} else if (field instanceof InputText.Component) {
							if (!field.value) {
								isFilled = false;
							} else {
								const customLength = customTextList.find(x => x.id === grandChild.id);
								if (customLength) {
									const textAlert = grandChild.component_outerChilds.find(x => x.id === 'lengthAlert');
									if (!textAlert) {
										this.component_throwUserError('Missing text alert for field ' + grandChild.id, {
											field: grandChild
										});
									}
									if (field.value.length > customLength.length) {
										isFilled = false;
										await textAlert.component_enable();
									} else {
										await textAlert.component_disable();
									}
								}
							}
						}
					}
				} else {
					const field = child.component_outerChilds.find(x => x.id === 'field');
					if (field instanceof InputText.Component) {
						if (!field.value) {
							isFilled = false;
						} else {
							const customLength = customTextList.find(x => x.id === child.id);
							if (customLength) {
								const textAlert = child.component_outerChilds.find(x => x.id === 'lengthAlert');
								if (!textAlert) {
									this.component_throwUserError('Missing text alert for field ' + child.id, {
										field: child
									});
								}
								if (field.value.length > customLength.length) {
									isFilled = false;
									await textAlert.component_enable();
								} else {
									await textAlert.component_disable();
								}
							}
						}
						if (child.id === 'email' && field.value) {
							field.component_DOM.checkValidity();
							if (!field.component_DOM.validity.valid) {
								isFilled = false;
								(<Block.Component>child).component_DOM.classList.add('wrongMail');
							} else {
								(<Block.Component>child).component_DOM.classList.remove('wrongMail');
							}
						}

					} else if (field instanceof InputSelect.Component) {
						if (!field.value) {
							isFilled = false;
						}
					}
				}
			}
		}
		const validateButton = <InputButton.Component>this.component_find('@@@:footer.yes');
		if (isFilled) {
			validateButton.component_DOM.classList.remove('notReady');
		} else {
			validateButton.component_DOM.classList.add('notReady');
		}
		return isFilled;
	}

	async validate() {
		if (!this.value) {
			this.component_throwLibraryError('Cannot validate if there are no value!', {});
		}
		if (!await this.checkAllField()) {
			return void 1;
		}
		// const buttonValidate = <InputButton.Component> this.component_find('@:process');
		// if (buttonValidate.component_DOM.classList.contains('notReady')) {
		// 	return;
		// }
		// let empty : CM.DOMComponent<any, any, any> | null = null;
		// let field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.name.field');
		// if (this.value.nameFirst.trim().length === 0) {
		// 	empty = field;
		// } else {
		// 	field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.company.field');
		// 	if (this.value.company.trim().length === 0) {
		// 		empty = field;
		// 	} else {
		// 		field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.email.field');
		// 		if (
		// 			(this.value.email.trim().length === 0) ||
		// 			!field.component_DOM.validity.valid
		// 		)
		// 		{
		// 			empty = field;
		// 		} else {
		// 			field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.phone.field');
		// 			if (this.value.phone.trim().length === 0) {
		// 				empty = field;
		// 			} else {
		// 				field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.country.field');
		// 				if (this.value.country.trim().length === 0) {
		// 					empty = field;
		// 				} else {
		// 					field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.event.field');
		// 					if (this.value.event.trim().length === 0) {
		// 						empty = field;
		// 					} else {
		// 						field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.booth.field');
		// 						if (this.value.booth.trim().length === 0) {
		// 							empty = field;
		// 						} else {
		// 							field = <CM.DOMComponent<any, any, any>> this.component_find('@:fields.agreeTermsAndCondition.field');
		// 							if (!this.value.isTOSAccepted) {
		// 								empty = field;
		// 							}
		// 						}
		// 					}
		// 				}
		// 			}
		// 		}
		// 	}
		// }
		// void empty;
		if (!app.basket) {
			this.component_throwLibraryError('', {});
		}
		const contact = new BasketNS.Contact();
		app.basket.basket.billingContact = contact;
		app.basket.basket.deliveryContact = contact;

		// country : string;
		// event : string;
		// booth : string;
		const SPA = this.value.standPositionA;
		contact.set('companyName', this.value.company);
		contact.set('firstName', this.value.nameFirst);
		contact.set('lastName', this.value.nameLast);
		contact.set('countryCode', this.value.country);
		contact.set('postcode', this.value.zipCode.toString());
		contact.set('city', this.value.city);
		contact.set('address', this.value.address);
		contact.set('email', this.value.email);
		contact.set('phone', this.value.phone);
		contact.set('metadata', {
			isTOSAccepted: this.value.isTOSAccepted,
			standPositionA: SPA,
			function: this.value.function ? this.value.function : '',
			event: this.value.event,
			position: `${SPA.hall} ${SPA.position}`
		});
		// ppack.resolve(this.value);
		// if (empty) {
		// 	ev.stopImmediatePropagation();
		// 	ev.stopPropagation();
		// 	const c = empty;
		// 	c.component_stylize({
		// 		border : '1px solid red'
		// 	}, 'self');
		// 	setTimeout(() => {
		// 		c.component_stylize({
		// 			border : ''
		// 		}, 'self');
		// 	}, 1000);
		// }
		return this.value;
	};

	async reset() {
		//do nothing because this need to be more thinked.
	};

	serialize() {
		return this.value;
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IOMSCustomerFormComponentConfiguration
	) {
		super(descriptor, Object.assign(
				{},
				configuration,
				{
					defaultValue: {
						name: '',
						company: '',
						email: '',
						phone: '',
						country: '',
						event: '',
						booth: '',
						function: '',
						standPositionA: {
							hall: '',
							// aisle :  '',
							// number : 0
							position: ''
						},
						isTOSAccepted: false
					}
				}
			)
		);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({});
	};
};
export namespace NS {
	export type Component = OMSCustomerFormComponent;
	export const Component = OMSCustomerFormComponent;
	export type Configuration = IOMSCustomerFormComponentConfiguration;
}
import './OMSCustomerForm.scss';
import manifestXMLSource from './OMSCustomerForm.xml';

CM.Manager.declare({
	id: 'oms-customerForm',
	type: OMSCustomerFormComponent,
	manifest: manifestXMLSource
});
